var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "decorfinder-wrapper" }, [
    _c("div", { staticClass: "global-modal__content" }, [
      _vm.hasHeader()
        ? _c(
            "div",
            { staticClass: "global-modal__header" },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "global-modal__body" }, [_vm._t("body")], 2),
      _vm._v(" "),
      _vm.hasPagination()
        ? _c(
            "div",
            { staticClass: "global-modal__pagination" },
            [_vm._t("pagination")],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }